module.exports = __webpack_public_path__ + "static/media/commentswhiteicon.f998f7ec.svg";